
















































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeContratosStore from '@/components/RemuneracaoMedica/contratos/Store/BackofficeContratosStore'

@Component
export default class ComponentModalAddGestores extends Vue {
  addgstLoading: boolean = false

  get getBackofficeContratosStore() {
    return getModule(BackofficeContratosStore, this.$store)
  }

  get addGestoresLoading() {
    return this.addgstLoading
  }

  set addGestoresLoading(value: boolean) {
    this.addgstLoading = value
  }

  get selected() {
    return this.getBackofficeContratosStore.selectedGestores
  }

  set selected(value: any[]) {
    this.getBackofficeContratosStore.setSelectedGestores(value)
  }

  get gestoresSearch() {
    return this.getBackofficeContratosStore.gestoresSearch
  }

  set gestoresSearch(value: string) {
    this.getBackofficeContratosStore.setGestoresSearch(value)
  }

  get addGestoresList() {
    return this.getBackofficeContratosStore.modal.addGestoresList
  }

  get gestoresTableHeader() {
    return this.getBackofficeContratosStore.gestoresTableHeader
  }

  get gestores() {
    return this.getBackofficeContratosStore.gestores
  }

  formatCPFOnly(c: string) {
    if (!c) return ''
    return `${c.substring(0, 3)}.${c.substring(3, 6)}.${c.substring(6, 9)}-${c.substring(9, 11)}`
  }

  closeModalGestores() {
    this.getBackofficeContratosStore.clearGestores()
    this.getBackofficeContratosStore.clearGestoresSearch()
    this.getBackofficeContratosStore.clearSelectedGestores()
    this.getBackofficeContratosStore.setShowModalAddGestoresList(false)
  }

  async addGestores() {
    this.addGestoresLoading = true
    await this.getBackofficeContratosStore.addGestores()
    this.addGestoresLoading = false
    this.closeModalGestores()
  }
}
